"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferenceName = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
exports.PreferenceName = Object.fromEntries([
    ...Object.entries(bridge_schema_1.PreferenceBoolOption)
        .filter(([key]) => Number.isNaN(parseInt(key)))
        .map(([key]) => [key, key]),
    ['Language', 'Language'],
    ['TabsOrder', 'TabsOrder'],
]);
